import React, { useEffect, useState } from "react";
import { Tabs, TabList, TabPanels, Tab, TabPanel, Button, Box, Flex, Image, Text } from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { constant } from "common/constant";
import "common/assets/css/viewEdit.css";
import { MdOutlineDashboard } from "react-icons/md"; 
import { MdEmail } from "react-icons/md";
import { MdCall } from "react-icons/md";
import { MdVideoCall } from "react-icons/md"; 
import { MdAttachFile } from "react-icons/md"; 
import { TaskIcon } from "common/assets/svg/TaskIcon";
import HomeIcon from "common/assets/svg/HomeIcon";
import EmailIcon from "common/assets/svg/EmailIcon";
import CallIcon from "common/assets/svg/CallIcon";
import TaskIcons from "common/assets/svg/TaskIcons";
import AttachmentIcon from "common/assets/svg/AttachmentIcon";
import MeetingIcon from "common/assets/svg/MeetingIcon";
import BackIcon from "common/assets/img/BackIcon.png";

const tabIconMap = {
  Overview: <HomeIcon />,
  Emails: <EmailIcon />,
  "Call Logs": <CallIcon />,
  Tasks: <TaskIcons />
  ,
  Meetings: <MeetingIcon />,
  Attachments: <AttachmentIcon />,
};

const ViewEdit = ({ tabs = {}, backRoute,  title = "" }) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const tabKeys = Object.keys(tabs);
  const navigate = useNavigate();

  useEffect(() => {
    const savedTabIndex = localStorage.getItem("selectedTabIndex");
    const savedTabKeys = JSON.parse(localStorage.getItem("tabsKeys"));

    if (savedTabIndex !== null && savedTabKeys && savedTabKeys.length === tabKeys.length) {
      if (savedTabKeys.every((key, index) => key === tabKeys[index])) {
        setSelectedTabIndex(parseInt(savedTabIndex, 10));
      } else {
        setSelectedTabIndex(0);
      }
    } else {
      setSelectedTabIndex(0);
    }
  }, [tabKeys]);

  useEffect(() => {
    if (selectedTabIndex !== 0) {
      localStorage.setItem("selectedTabIndex", selectedTabIndex);
      localStorage.setItem("tabsKeys", JSON.stringify(tabKeys));
    }
  }, [selectedTabIndex, tabKeys]);

     useEffect(() => {
    document.body.classList.add("bgWhiteImp");
    return () => {
      document.body.classList.remove("bgWhiteImp");
    };
  }, []);

  const handleTabChange = (index) => {
    setSelectedTabIndex(index);
    localStorage.setItem("selectedTabIndex", index);
  };
  const handleBackBtn = () => {
   navigate(-1);
  }

  return (
    <Tabs
      className="viewEditMainContainer"
      index={selectedTabIndex}
      onChange={handleTabChange}
    >
       <Box className="backNavigationTitle">
          <Image src={BackIcon} cursor={"pointer"} onClick={handleBackBtn} height={"16px"} width={"16px"} alt="back" className="" />
          <Text className="pageDetailTitle">{title} Details</Text>
        </Box>
      <Flex className="viewEditHeader">       
        {/* Tab Navigation */}
        <Box>
          <TabList className="viewEditTabList">
            {tabKeys.map((key, index) => (
              <Tab className="viewEditTabBtns" key={key}>
                <Flex align="center" gap="8px">
                  {tabIconMap[key]}
                  {key}
                </Flex>
              </Tab>
            ))}
          </TabList>
        </Box>

        {/* Back Button */}
        {/* <Box>
          <Link to={backRoute}>
            <Button leftIcon={<IoIosArrowBack />} className="viewEditTabBackBtn">
              {constant.back}
            </Button>
          </Link>
        </Box> */}
      </Flex>

      {/* Tab Panels */}
      <TabPanels className="viewEditBody">
        {tabKeys.map((key, index) => (
          <TabPanel className="viewEditTabPanel" key={key}>
            {selectedTabIndex === index && tabs[key]}
          </TabPanel>
        ))}
      </TabPanels>

    </Tabs>
  );
};

export default ViewEdit;
